import React from 'react';
import { translate } from 'react-i18next';

class Footer extends React.Component {
	render() {
  	return (
      <footer>
        <div className="footer-left">
          {window.EmployeeWeb.ENVConfig.brand === 'jonas' &&
            <ul>
              <li>{this.props.t('Footer.powered_by_jonas')}</li>
              {window.EmployeeWeb.ENVConfig.privacy_link &&
                <li><a target="_blank" href={window.EmployeeWeb.ENVConfig.privacy_link}>{this.props.t('Footer.privacy_policy')}</a></li>
              }
            </ul>
          }
        </div>
        <div className="footer-right">
          {window.EmployeeWeb.ENVConfig.brand === 'jonas' &&
            <span>
              {window.location.pathname === '/' &&
                <a href={window.EmployeeWeb.ENVConfig.parent_link} target="_blank">
                  <img src="/images/brands/jonas/jonasclub_logo.png" />
                </a>

              }
            </span>
          }
        </div>
      </footer>
    )
  }
}

export default translate()(Footer);
